import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useGlobalState from 'Hooks/useGlobalState';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import { ReactComponent as LogoIcon } from "assets/logo.svg";

const AdminMenu = (props) => {
	const [ { user }, globalState] = useGlobalState();
	const navigate = useNavigate();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position="static" style={{ backgroundColor: '#4672D5' }}>
				<Toolbar>
					<IconButton
						size="large"
						edge="start"
						color="inherit"
						aria-label="menu"
						sx={{ mr: 2 }}
						onClick={() => { navigate('/admin/organisation/' + user.org.uuid); handleClose(); }}
					>
						<LogoIcon style={{ width: '60px' }} />
					</IconButton>
					<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
						{globalState.adminTitle}
					</Typography>
					<div>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleMenu}
							color="inherit"
						>
							<MenuIcon />
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorEl}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'right',
							}}
							keepMounted
							transformOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
							open={Boolean(anchorEl)}
							onClose={handleClose}
						>
							<MenuItem onClick={() => { navigate('/admin/organisation/' + user.org.uuid); handleClose(); }}>Min organisation</MenuItem>
							<MenuItem onClick={() => { navigate('/admin/organisation/' + user.org.uuid + '/movedevices'); handleClose(); }}>Flyt enheder</MenuItem>
							<MenuItem onClick={() => { navigate('/admin/organisation/' + user.org.uuid + '/exportdata'); handleClose(); }}>Exporter data</MenuItem>
							<MenuItem onClick={() => { navigate('/admin/organisation/' + user.org.uuid + '/notifications'); handleClose(); }}>Notifikationer</MenuItem>
							{/* <MenuItem onClick={() => { navigate('/admin/organisation'); handleClose(); }}>Enheder</MenuItem> */}
						</Menu>
					</div>
				</Toolbar>
			</AppBar>
		</Box>
	);
};

export default AdminMenu;